"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _gift = require("../../store/gift/gift.selector");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      height: 80,
      width: 80,
      marginRight: theme.spacing(2)
    },
    fakeAvatar: {
      backgroundColor: theme.palette.divider
    },
    fakeAvatarIcon: {
      width: 'initial',
      color: theme.palette.common.white,
      fontSize: '2rem',
      height: '2rem'
    }
  };
});

var GiftMessageSender = function GiftMessageSender() {
  var classes = useStyles();
  var sender = (0, _reactRedux.useSelector)(_gift.getGiftSender);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      user = _useGiftContext.user;

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, sender.avatar ? /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    src: sender.avatar,
    className: classes.avatar,
    alt: sender.full_name
  }) : /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    alt: sender.full_name,
    className: (0, _classnames.default)(classes.avatar, classes.fakeAvatar)
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "user",
    className: classes.fakeAvatarIcon
  })), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, sender.full_name), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, sender.position, !!sender.position && ' at ', sender.company || user.orgName), /*#__PURE__*/_react.default.createElement("a", {
    className: "Subcopy-Regular-Link",
    href: "mailto:".concat(sender.email)
  }, sender.email), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, sender.phone)));
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftMessageSender);

exports.default = _default;